export default function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div className={`faq-item ${isOpen ? 'is-open' : ''}`}>
      <button
        type="button"
        className="faq-item__question"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{question}</span>
        <span className="faq-item__icon" aria-hidden="true">
          <span className="faq-item__icon-line faq-item__icon-line--v" />
          <span className="faq-item__icon-line faq-item__icon-line--h" />
        </span>
      </button>

      <div className="faq-item__answer-wrap">
        <p className="faq-item__answer">{answer}</p>
      </div>
    </div>
  );
}